import VersionApi from '../api/patient/VersionApi';
import store from '../store';
import { update } from '../store/appInfo/actions';

export async function loadAppInfo() {
  return VersionApi.getVersion().then(({ data }) => {
    console.log('Application version:');
    console.log(data);
    store.dispatch(update(data));
    return data;
  });
}
